import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setBackButtonUrl } from '../pages/uiSlice';
import {
  getGameAssignment,
  getPreviousPlayedStagePath,
  readStoredUserData,
} from './gameStages';
import { fetchReport } from '../functions/fetchReport';

export function useStageBackButton(stageNumber) {
  const dispatch = useDispatch();
  const { status, user } = useSelector((state) => state.auth);

  useEffect(() => {
    let cancelled = false;

    async function resolveBackUrl() {
      const stored = readStoredUserData();
      const game = getGameAssignment(stored);
      let report = stored?.report ?? null;

      const userId = user?.userId;
      const organizationId = user?.organizationId;
      const sessionId = user?.sessionId;
      const token =
        sessionId && organizationId ? `${sessionId}&${organizationId}` : null;

      if (!report && token && userId) {
        try {
          const resp = await fetchReport({ userId, token, sessionId, organizationId });
          report = resp?.report ?? null;
        } catch {
          /* use cached progress only */
        }
      }

      const path =
        getPreviousPlayedStagePath(stageNumber, report, game) || '/rules';

      if (!cancelled) {
        dispatch(setBackButtonUrl(path));
      }
    }

    resolveBackUrl();

    return () => {
      cancelled = true;
    };
  }, [stageNumber, status, user, dispatch]);
}
